import React from 'react';
import './Chapters.scss';
import graphicImg2 from '../../assets/graphicImg2.svg';
function Chapter7() {
  return (
    <section className="chapter" style={{ marginBottom: '4rem' }}>
      <h3 className="chapter__title">Creating a Virtuous Cycle for Increased Donations</h3>
      <p className="chapter__paragraph">
        Peak also helps generate personalized impact reports that FareShare GM can use to show its
        donors and suppliers how their donations are used and how many people were helped. Until
        now, FareShare GM produced those reports manually, a time-consuming process that could take
        days to create a single report. Peak built an automated process that enabled FareShare GM to
        grab key data and generate a statistical impact report in less than 30 seconds filled with
        detailed analysis that traces donated food over a designated time frame from their source to
        the communities who ultimately benefitted from those donations.
      </p>
      <p className="chapter__paragraph">
        Nummedal says that automating the creation of impact reports has enabled FareShare GM to
        keep its donors better informed. Since Peak automated the report creation process, FareShare
        GM is producing four times as many impact reports as before. This has created a more
        virtuous circle with stronger donor engagement leading to more donations. “It’s gratifying
        to see that we’re having a tangible impact that helps FareShare and ultimately benefits the
        wider community,” he says.
      </p>

      <img src={graphicImg2} alt="graphic" />
    </section>
  );
}

export default Chapter7;
